import ContentWithCards from "../components/shared/ContentWithCards";

const Events = () => {
  return (
    <ContentWithCards>
      <div className="main-section bg-white border">
        <div className="p-3">
          <div className="flex flex-col mb-2">
            <h2 className="text-lg font-semibold text-gray-700 mb-3 text-center border-b py-2 font-heading">
              Events
            </h2>

            <div className="text-center flex justify-center items-center flex-col">
              <p className="text-gray-500 py-4 font-roboto-flex">
                No events available at the moment.
              </p>
              <div className="w-64 h-48 bg-gray-100 rounded-lg flex items-center justify-center">
                <div className="text-center text-gray-400">
                  <svg className="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p className="text-sm font-roboto-flex">Events Coming Soon</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentWithCards>
  );
};

export default Events;
